import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import Layout from '../../components/global/layout';
import ApiClient from '../../methods/api/apiClient';
import shared from './shared';
import loader from '../../methods/loader';
import methodModel from '../../methods/methods';
import { CgArrowLeft } from 'react-icons/cg';
import {
  MdOutlineNotifications,
  MdOutlineStore,
  MdOutlinePeople,
  MdOutlineMessage,
  MdOutlinePerson,
  MdOutlineCalendarToday,
  MdOutlineMarkEmailRead,
  MdOutlineScheduleSend,
} from 'react-icons/md';
import { HiCheckCircle, HiXCircle, HiClock } from 'react-icons/hi';

function ViewNotification() {
  const [data, setData] = useState({});
  const history = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    getDetail();
  }, []);

  const getDetail = () => {
    loader(true);
    ApiClient.get(shared.detailApi, { id }).then((res) => {
      loader(false);
      if (res.success) {
        console.log(res?.data, "data ----")
        setData(res.data);
      }
    });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  const StatusBadge = ({ value }) => {
    const isActive = value === 'active';
    return (
      <span
        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold capitalize ${isActive
          ? 'bg-green-100 text-green-700'
          : 'bg-red-100 text-red-600'
          }`}
      >
        {isActive ? <HiCheckCircle className="text-sm" /> : <HiXCircle className="text-sm" />}
        {value || '—'}
      </span>
    );
  };

  const SentBadge = ({ isSent = true }) => (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold ${isSent
        ? 'bg-green-100 text-green-700'
        : 'bg-amber-100 text-amber-700'
        }`}
    >
      {isSent ? (
        <><MdOutlineMarkEmailRead className="text-sm" /> Sent</>
      ) : (
        <><MdOutlineScheduleSend className="text-sm" /> Pending</>
      )}
    </span>
  );

  const SectionHeader = ({ icon: Icon, title, color = '#CC9900' }) => (
    <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-100">
      <span
        className="w-8 h-8 rounded-lg flex items-center justify-center text-white text-base"
        style={{ background: color }}
      >
        <Icon />
      </span>
      <h4 className="text-[15px] font-semibold text-[#1a1a2e]">{title}</h4>
    </div>
  );

  const venues = data?.venueIds || [];
  const customers = data?.customerIds || [];
  const addedBy = data?.addedBy;

  return (
    <Layout>
      <style>{`
        .notif-card {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 2px 20px -4px rgba(0,0,0,0.08);
          border: 1px solid #f0f0f0;
          padding: 24px;
          transition: box-shadow 0.2s;
        }
        .notif-card:hover {
          box-shadow: 0 6px 28px -6px rgba(0,0,0,0.12);
        }
        .avatar-ring {
          outline: 3px solid #CC9900;
          outline-offset: 2px;
        }
        .venue-chip {
          background: linear-gradient(135deg, #fff8e0, #fff3c4);
          border: 1px solid #f5cc3b44;
          border-radius: 12px;
          padding: 14px;
          display: flex;
          align-items: center;
          gap: 12px;
          transition: transform 0.15s, box-shadow 0.15s;
        }
        .venue-chip:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px -4px rgba(204,153,0,0.2);
        }
        .customer-chip {
          background: linear-gradient(135deg, #f0f6ff, #e6f0ff);
          border: 1px solid #c7d9f544;
          border-radius: 12px;
          padding: 14px;
          display: flex;
          align-items: center;
          gap: 12px;
          transition: transform 0.15s, box-shadow 0.15s;
        }
        .customer-chip:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px -4px rgba(59,130,246,0.2);
        }
        .meta-row {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 14px;
          background: #fafafa;
          border-radius: 10px;
          border: 1px solid #f0f0f0;
        }
        .meta-label {
          font-size: 12px;
          color: #999;
          font-weight: 500;
          min-width: 100px;
        }
        .meta-value {
          font-size: 13px;
          color: #2d2d2d;
          font-weight: 600;
        }
      `}</style>

      <div className="wrapper_section">
        {/* Header */}
        <div className="flex gap-3 justify-between flex-wrap mb-8">
          <div className="flex items-center">
            <Tooltip placement="top" title="Back">
              <span
                onClick={() => history(-1)}
                className="!px-4 py-2 cursor-pointer flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3 bg-[#CC9900] text-white hover:text-black"
              >
                <CgArrowLeft />
              </span>
            </Tooltip>
            <div>
              <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">
                Notification Details
              </h3>
              <p className="text-sm text-gray-400 mt-0.5">Full breakdown of the notification</p>
            </div>
          </div>

          {/* Status pills */}
          <div className="flex items-center gap-2">
            <StatusBadge value={data?.status} />
            <SentBadge isSent={true} />
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6">

          {/* ── Left column ── */}
          <div className="col-span-12 lg:col-span-8 flex flex-col gap-6">

            {/* Notification Info Card */}
            <div className="notif-card">
              <SectionHeader icon={MdOutlineNotifications} title="Notification Info" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="text-[12px] text-gray-400 font-medium tracking-wide uppercase mb-1.5 block">
                    Title
                  </label>
                  <p className="text-[15px] font-semibold text-[#1a1a2e]">
                    {data?.title || '—'}
                  </p>
                </div>
                <div>
                  <label className="text-[12px] text-gray-400 font-medium tracking-wide uppercase mb-1.5 block">
                    Status
                  </label>
                  <StatusBadge value={data?.status} />
                </div>
                <div className="sm:col-span-2">
                  <label className="text-[12px] text-gray-400 font-medium tracking-wide uppercase mb-1.5 block">
                    <MdOutlineMessage className="inline mr-1 mb-0.5" />
                    Message
                  </label>
                  <div className="relative bg-gradient-to-br from-[#fffbeb] to-[#fff8dc] border border-[#f5cc3b33] rounded-xl p-4 text-[14px] text-[#444] leading-relaxed">
                    <span className="absolute top-3 left-3 text-[#CC9900]/30 text-4xl font-serif leading-none">"</span>
                    <p className="pl-5 pt-1">{data?.message || '—'}</p>
                    <span className="absolute bottom-2 right-4 text-[#CC9900]/30 text-4xl font-serif leading-none">"</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Venues Card */}
            <div className="notif-card">
              <SectionHeader icon={MdOutlineStore} title={`Targeted Venues (${venues.length})`} color="#CC9900" />
              {venues.length === 0 ? (
                <p className="text-sm text-gray-400 italic">No venues targeted.</p>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {venues.map((v) => (
                    <div key={v._id} className="venue-chip">
                      <div className="w-11 h-11 rounded-xl overflow-hidden flex-shrink-0 bg-[#CC9900]/10 flex items-center justify-center">
                        {v.logo ? (
                          <img
                            src={methodModel.noImg(v.logo)}
                            alt={v.name}
                            className="w-full h-full object-cover"
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        ) : (
                          <MdOutlineStore className="text-[#CC9900] text-xl" />
                        )}
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-[13px] font-bold text-[#1a1a2e] capitalize truncate">{v.name}</p>
                        <p className="text-[11px] text-gray-400 truncate">{v.email}</p>
                        <div className="flex items-center gap-2 mt-1">
                          <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full capitalize ${v.status === 'active' ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-500'}`}>
                            {v.status}
                          </span>
                          <span className="text-[10px] text-gray-400 capitalize">{v.type}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Customers Card */}
            <div className="notif-card">
              <SectionHeader icon={MdOutlinePeople} title={`Targeted Customers (${customers.length})`} color="#3B82F6" />
              {customers.length === 0 ? (
                <p className="text-sm text-gray-400 italic">No customers targeted.</p>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {customers.map((c) => (
                    <div key={c.id} className="customer-chip">
                      <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 bg-blue-100 flex items-center justify-center avatar-ring">
                        {c.image ? (
                          <img
                            src={methodModel.noImg(c.image)}
                            alt={c.fullName}
                            className="w-full h-full object-cover"
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        ) : (
                          <span className="text-blue-500 text-lg font-bold">
                            {c.firstName?.[0]?.toUpperCase() || '?'}
                          </span>
                        )}
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-[13px] font-bold text-[#1a1a2e] capitalize truncate">{c.fullName || `${c.firstName} ${c.lastName}`.trim()}</p>
                        <p className="text-[11px] text-gray-400 truncate">{c.email}</p>
                        <div className="flex items-center gap-2 mt-1 flex-wrap">
                          <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full capitalize ${c.status === 'active' ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-500'}`}>
                            {c.status}
                          </span>
                          <span className="text-[10px] text-[#CC9900] font-semibold bg-amber-50 px-2 py-0.5 rounded-full">
                            ⭐ {c.tavloyPoints ?? 0} pts
                          </span>
                          {c.dialCode && c.mobileNo && (
                            <span className="text-[10px] text-gray-400">+{c.dialCode} {c.mobileNo}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* ── Right column ── */}
          <div className="col-span-12 lg:col-span-4 flex flex-col gap-6">

            {/* Sent By Card */}
            {addedBy && (
              <div className="notif-card">
                <SectionHeader icon={MdOutlinePerson} title="Sent By" color="#8B5CF6" />
                <div className="flex flex-col items-center text-center gap-3 pt-1">
                  <div className="w-16 h-16 rounded-full overflow-hidden border-4 border-purple-100 bg-purple-50 flex items-center justify-center">
                    {addedBy.image ? (
                      <img
                        src={methodModel.noImg(addedBy.image)}
                        alt={addedBy.fullName}
                        className="w-full h-full object-cover"
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                    ) : (
                      <span className="text-purple-500 text-2xl font-bold">
                        {addedBy.firstName?.[0]?.toUpperCase() || 'A'}
                      </span>
                    )}
                  </div>
                  <div>
                    <p className="text-[15px] font-bold text-[#1a1a2e] capitalize">{addedBy.fullName}</p>
                    <p className="text-[12px] text-gray-400">{addedBy.email}</p>
                    <p className="text-[11px] text-gray-400 mt-0.5">+{addedBy.mobileNo}</p>
                  </div>
                  <div className="w-full pt-2 border-t border-gray-100">
                    <StatusBadge value={addedBy.status} />
                  </div>
                </div>
              </div>
            )}

            {/* Timeline Card */}
            <div className="notif-card">
              <SectionHeader icon={MdOutlineCalendarToday} title="Timeline" color="#10B981" />
              <div className="flex flex-col gap-3">
                <div className="meta-row">
                  <HiClock className="text-green-500 flex-shrink-0" />
                  <div>
                    <p className="meta-label">Created At</p>
                    <p className="meta-value">{formatDate(data?.createdAt)}</p>
                  </div>
                </div>
                <div className="meta-row">
                  <HiClock className="text-blue-400 flex-shrink-0" />
                  <div>
                    <p className="meta-label">Updated At</p>
                    <p className="meta-value">{formatDate(data?.updatedAt)}</p>
                  </div>
                </div>
                <div className="meta-row">
                  {data?.isSent ? (
                    <MdOutlineMarkEmailRead className="text-green-500 flex-shrink-0" />
                  ) : (
                    <MdOutlineScheduleSend className="text-amber-500 flex-shrink-0" />
                  )}
                  <div>
                    <p className="meta-label">Sent At</p>
                    <p className="meta-value">{data?.sentAt ? formatDate(data.sentAt) : 'Not sent yet'}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </Layout>
  );
}

export default ViewNotification;
